import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { DictionaryItemDto, DictionaryTypeDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { RefetchModel } from '@/api/model/Refetch.model.ts';

export type DictionariesType = Record<DictionaryTypeDto, DictionaryItemDto[]>;

interface Return {
  dictionaries?: DictionariesType;
  getAllDictionaries: RefetchModel<DictionariesType>;
  isFetchingDictionariesTypes: boolean;
}

export const useGetAllDictionaries = (): Return => {
  const { dictionariesApi } = useApiClient();

  const { data, isLoading, refetch } = useQuery<DictionariesType, AxiosError>({
    queryFn: async () => {
      const response = await dictionariesApi.getDictionaries(0, 10000, {});
      const dicts: DictionariesType = {
        [DictionaryTypeDto.CarDeadlineType]: [],
        [DictionaryTypeDto.CarType]: [],
        [DictionaryTypeDto.DietaryPreference]: [],
        [DictionaryTypeDto.DishDepartment]: [],
        [DictionaryTypeDto.DishType]: [],
        [DictionaryTypeDto.EmergencyContactCategoryType]: [],
        [DictionaryTypeDto.EventType]: [],
        [DictionaryTypeDto.MenuType]: [],
        [DictionaryTypeDto.PackageOfferItem]: [],
        [DictionaryTypeDto.PredefinedOffer]: [],
        [DictionaryTypeDto.SupplierType]: [],
        [DictionaryTypeDto.Tag]: [],
      };
      response.data.items.forEach(it => {
        dicts[it.type].push(it);
      });

      return dicts;
    },
    queryKey: [QueryKeyEnum.DICTIONARIES.ALL],
  });

  return {
    dictionaries: data,
    getAllDictionaries: refetch,
    isFetchingDictionariesTypes: isLoading,
  };
};
